'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var onLineView = function onLineView() {
  return import('@/page/class');
};
var onLineList = function onLineList() {
  return import('@/page/class/class-list');
};
var onLineDetail = function onLineDetail() {
  return import('@/page/class/class-detail');
};
var courseDetail = function courseDetail() {
  return import('@/page/course/course-detail');
};
var classResourse = function classResourse() {
  return import('@/page/class/class-menu/resourse');
};
var onLineCertificate = function onLineCertificate() {
  return import('@/page/class/class-menu/certificate');
};
var classAlbum = function classAlbum() {
  return import('@/page/class/class-menu/album');
};
var certificateDetail = function certificateDetail() {
  return import('@/page/class/class-menu/certificate-detail');
};
var communicationDetail = function communicationDetail() {
  return import('@/page/class/class-detail/communication-detail');
};

exports.default = [{
  path: '/onLine',
  name: 'onLine',
  component: onLineView,
  children: [{
    path: 'onLine-list',
    name: 'onLine-list',
    component: onLineList
  }, {
    path: 'onLine-detail',
    name: 'onLine-detail',
    component: onLineDetail
  }, {
    path: 'course-detail',
    name: 'course-detail',
    component: courseDetail
  }, {
    path: 'onLine-certificate',
    name: 'onLine-certificate',
    component: onLineCertificate
  }, {
    path: 'class-resourse',
    name: 'class-resourse',
    component: classResourse
  }, {
    path: 'class-album',
    name: 'class-album',
    component: classAlbum
  }, {
    path: 'certificate-detail',
    name: 'certificate-detail',
    component: certificateDetail
  }, {
    path: 'communication-detail',
    name: 'communication-detail',
    component: communicationDetail
  }]
}];